import {Image, ImageProps, Text} from '@mantine/core';

export type ImagePreviewProps = ImageProps & {
  label?: string;
  uri?: string;
};

export const ImagePreview: React.FC<ImagePreviewProps> = (props) => {
  const {label, uri} = props;

  return uri ? (
    <>
      {label ? <Text>{label}</Text> : null}
      <Image src={uri} {...(props as ImageProps)} />
    </>
  ) : null;
};
